import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59f8ee76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-weight-bold" }, "직종별 합계", -1))
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "wage-table" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }

import { ref } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';

interface JobTotal {
  emp_job: string;
  emp_count: number;
  total: string;
  c_out: string;
  c_total: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WageDirectPay',
  setup(__props, { expose: __expose }) {

const store = useStore();
const dialog = ref(false);
const loading = ref(false);
const jobTotals = ref<JobTotal[]>([]);

const headers = [
  { title: '직종', key: 'emp_job', align: 'center' },
  { title: '인원', key: 'emp_count', align: 'center' },
  { title: '총액', key: 'total', align: 'center' },
  { title: '퇴직금', key: 'c_out', align: 'center' },
  { title: '공제합계', key: 'c_total', align: 'center' },
];

const fetchJobTotals = async () => {
  if (loading.value) return;
  loading.value = true;
  try {
    const response = await axios.get('/api/wage/job-totals', {
      params: {
        sisul_code: store.state.AdminSisulCode,
        ew_ym: store.state.AdminYYMM
      }
    });
    jobTotals.value = response.data;
    console.log(jobTotals.value,'jobTotals')
  } catch (error) {
    console.error('직종별 합계 조회 중 에러 발생:', error);
  } finally {
    loading.value = false;
  }
};

const openDialog = async () => {
  await fetchJobTotals();
  dialog.value = true;
};

__expose({
  openDialog
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialog).value = $event)),
    "max-width": "600px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_icon, {
                  color: "primary",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-account-group")
                  ]),
                  _: 1
                }),
                _hoisted_2
              ]),
              _createVNode(_component_v_btn, {
                icon: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (dialog.value = false))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-close")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "mt-0 pt-0" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("table", _hoisted_4, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header) => {
                        return _createElementVNode("th", {
                          key: header.key,
                          class: _normalizeClass({ 'text-end': header.align === 'end' })
                        }, _toDisplayString(header.title), 3)
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobTotals.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_5, _toDisplayString(item.emp_job), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(item.emp_count), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(item.total), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(item.c_out), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(item.c_total), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})